let html = `<div class="head-backward selector">
    <div class="head-backward__button">
        <svg><use xlink:href="#sprite-backward"></use></svg>
    </div>
    <div class="head-backward__title">{title}</div>
</div>`

export default html